import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AllTaxiTableDashComp.css";

export default function AllTaxiTableDashComp() {
  const [taxis, setTaxis] = useState([]);
  const [editingTaxiId, setEditingTaxiId] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchTaxis();
  }, []);

  const fetchTaxis = async () => {
    const res = await axios.get("/api/taxiforsale");
    setTaxis(res.data);
  };

  const handleEditClick = (taxi) => {
    setEditingTaxiId(taxi.id);
    setFormData(taxi);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    await axios.put(`/api/taxiforsale/${editingTaxiId}`, formData);
    setEditingTaxiId(null);
    fetchTaxis();
  };

  const handleDelete = async (id) => {
    if (window.confirm("האם אתה בטוח שברצונך למחוק את המונית הזו?")) {
      await axios.delete(`/api/taxiforsale/${id}`);
      fetchTaxis(); // רענון הרשימה אחרי מחיקה
    }
  };
  

  return (
<div className="taxi-table-wrapper">
  <h2 className="taxi-table-title">רשימת מוניות לעריכה</h2>
  <table className="taxi-table">
    <thead className="taxi-table-head">
      <tr className="taxi-table-row taxi-header-row">
        <th className="taxi-table-header">יצרן</th>
        <th className="taxi-table-header">דגם</th>
        <th className="taxi-table-header">מחיר</th>
        <th className="taxi-table-header">ק"מ</th>
        <th className="taxi-table-header">שנתון</th>
        <th className="taxi-table-header">טסט</th>
        <th className="taxi-table-header">תיאור</th>
        <th className="taxi-table-header">טלפון</th>
        <th className="taxi-table-header">אזור מגורים</th>
        <th className="taxi-table-header">בעלות</th>
        <th className="taxi-table-header">יד</th>
        <th className="taxi-table-header">תאריך עלייה לכביש</th>
        <th className="taxi-table-header">תמונות</th>
        <th className="taxi-table-header">פעולה</th>
      </tr>
    </thead>
    <tbody className="taxi-table-body">
      {taxis.map((taxi) => (
        <tr className="taxi-table-row" key={taxi.id}>
          {[
            "יצרן", "דגם", "מחיר", "קמ", "שנתון", "טסט", "תיאור",
            "טלפון", "אזור_מגורים", "בעלות", "יד", "תאריך_עלייה_לכביש", "תמונות"
          ].map((field) => (
            <td className="taxi-table-cell" key={field}>
              {editingTaxiId === taxi.id ? (
                <input
                  name={field}
                  value={formData[field] || ""}
                  onChange={handleChange}
                  className="taxi-input"
                />
              ) : (
                Array.isArray(taxi[field])
                  ? taxi[field].join(", ")
                  : taxi[field]
              )}
            </td>
          ))}
          <td className="taxi-table-cell">
            {editingTaxiId === taxi.id ? (
              <button className="taxi-button save" onClick={handleSave}>שמור</button>
            ) : (
              <>
                <button className="taxi-button edit" onClick={() => handleEditClick(taxi)}>ערוך</button>
                <button className="taxi-button delete" onClick={() => handleDelete(taxi.id)}>מחק</button>
              </>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

  );
}
